import { render } from "./NewAtiRouteForm.vue?vue&type=template&id=317ae580&scoped=true"
import script from "./NewAtiRouteForm.vue?vue&type=script&lang=js"
export * from "./NewAtiRouteForm.vue?vue&type=script&lang=js"

import "./NewAtiRouteForm.vue?vue&type=style&index=0&id=317ae580&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317ae580"]])

export default __exports__